import { useIntl } from 'react-intl';

import type { CountryCodeEnumType } from '@/types/regionTypes';

import type { SelectFieldProps } from '@/components/SelectField';
import { SelectField } from '@/components/SelectField';
import { formMessages } from '@/messages/forms';

import { getTitleOptions } from './utils';

interface Props extends Omit<SelectFieldProps, 'name'> {
  countryCode: string;
  name?: string;
}

export const TitleField = ({ countryCode, name, ...props }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <SelectField
      aria-label={formatMessage(formMessages.title)}
      colorVariant={props.colorVariant}
      data-test-id='selectTitle'
      flexProps={{ alignItems: 'flex-start', flexDirection: 'column' }}
      isDisabled={props.isDisabled}
      name={name ?? 'title'}
      options={getTitleOptions(
        formatMessage,
        countryCode as CountryCodeEnumType,
      )}
      placeholder={formatMessage(formMessages.title)}
    />
  );
};
